import React from 'react';
import { motion } from 'framer-motion';
import { Card } from './ui/card';
import { Clock, Zap, Users, TrendingUp } from 'lucide-react';

const WhyNowSection = () => {
  const urgencyPoints = [
    {
      icon: Users,
      title: "Ground Floor Opportunity",
      description: "Join as a founding investor in building the infrastructure layer for a $400B+ market. Help shape how trust and liquidity work in high-value collectibles."
    },
    {
      icon: TrendingUp,
      title: "Define Market Standards",
      description: "Be part of establishing the protocols and networks that will become industry standard. Your input influences how serious markets operate."
    },
    {
      icon: Zap,
      title: "Revenue From Day One",
      description: "Unlike traditional infrastructure plays, The Room generates immediate revenue while building network effects. No extended burn waiting for traction."
    },
    {
      icon: Clock,
      title: "Proven Network Forming",
      description: "May 2026 commitments are real. The foundation is being laid now. Early investors help build the trust layer before the platform scales."
    }
  ];

  return (
    <section className="py-16 lg:py-24 bg-gradient-to-b from-secondary/20 to-background">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-12"
        >
          <p className="uppercase tracking-[0.22em] text-xs text-muted-foreground mb-6">
            The Opportunity
          </p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold mb-6">
            Help Define The Future
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto leading-relaxed">
            Join us as a founding investor in shaping how high-value collectibles markets operate. <span className="font-semibold text-foreground">This is about building infrastructure that lasts.</span>
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-6xl mx-auto">
          {urgencyPoints.map((point, index) => {
            const Icon = point.icon;
            return (
              <motion.div
                key={point.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <Card className="p-6 h-full hover:shadow-lg transition-all hover:scale-[1.02] border-accent/20">
                  <div className="flex items-start gap-4">
                    <div className="bg-accent/10 p-3 rounded-lg flex-shrink-0">
                      <Icon className="h-6 w-6 text-accent" />
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold mb-2">{point.title}</h3>
                      <p className="text-sm text-muted-foreground leading-relaxed">
                        {point.description}
                      </p>
                    </div>
                  </div>
                </Card>
              </motion.div>
            );
          })}
        </div>

        {/* Investment Ask CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="mt-12 text-center"
        >
          <Card className="p-8 max-w-3xl mx-auto bg-primary text-primary-foreground border-none">
            <p className="text-xl font-semibold mb-2">Join The Founding Round</p>
            <p className="text-3xl sm:text-4xl font-bold mb-4">$2.5M at $15M–$20M Pre-Money</p>
            <p className="text-sm opacity-90">
              Get in early. Build with us. Help define how trust infrastructure works for high-value markets.
            </p>
          </Card>
        </motion.div>
      </div>
    </section>
  );
};

export default WhyNowSection;
